import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { productBrief } from "../data/productBrief";
export function WorkshopsSection() {
  return <section className="section wash" id="workshops" aria-labelledby="workshops-heading" data-id="element-287" data-mp="16pmi5sj7mcrv">
      <div className="shell" data-id="element-288" data-mp="1boz4mc665htx">
        <div className="section-intro" data-id="element-289" data-mp="1bo66fzla00ne">
          <p className="eyebrow" data-id="element-290" data-mp="1bn4qphtbepzc">VOLUME 1 · THE 5 WORKSHOPS</p>
          <h2 id="workshops-heading" data-id="element-291" data-mp="f09l6hew8h5u">
            Five foundational skills, <span data-id="element-292" data-mp="j0a9ctrso6q3">one planned session at a time</span>
          </h2>
          <p data-id="element-293" data-mp="iyh51l4nlyl9">
            Opening, discovery, fit, value and price conversations. Run them in sequence or pick the skill your
            team needs next.
          </p>
        </div>
        <ol className="workshop-list" data-id="element-294" data-mp="srxz8q8pdfpg">
          {productBrief.workshops.map(workshop => <li key={workshop.number} data-id="element-295" data-mp="3rftybglfn2zc">
              <span className="workshop-number" aria-hidden="true" data-id="element-296" data-mp="a2bor6v68ha">
                {String(workshop.number).padStart(2, "0")}
              </span>
              <div data-id="element-297" data-mp="1ssq7rfxchaiq">
                <h3 data-id="element-298" data-mp="1st8dr49t733u">{workshop.title}</h3>
                <p data-id="element-299" data-mp="1orwhifwfjjmo">{workshop.outcome}</p>
                <span className="workshop-vol" data-id="element-300" data-mp="1osy6loaa66ne">VOLUME {workshop.volume}</span>
              </div>
            </li>)}
        </ol>
        <div className="section-action" data-id="element-301" data-mp="1f2mpf01l60yk">
          <CtaButton href="#offer-details" data-id="element-302" data-mp="1f1k0uyrqkalt">
            See the Volume 1 offer — $27 <ArrowRightIcon size={18} aria-hidden="true" data-id="element-303" data-mp="1a3a0m9r5mjtc" />
          </CtaButton>
        </div>
      </div>
    </section>;
}